// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/design-system/components/forms/TextArea.jsx

import React, { forwardRef } from "react";
import "./forms.css";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

const TextArea = forwardRef(function TextArea(
  { size = "medium", className = "", ...textareaProps },
  ref
) {
  return (
    <textarea
      {...textareaProps}
      ref={ref}
      className={joinClassNames(
        "oasys-control",
        "oasys-text-area",
        size !== "medium" && `oasys-control--${size}`,
        className
      )}
    />
  );
});

export default TextArea;
